import PrsPersonList from '@/modules/person/views/PrsPersonList';
import PrsPerson from '@/modules/person/views/PrsPerson';

export default [
	{
		path: '/prsperson/list',
		name: 'prspersonlist',
		component: PrsPersonList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/prsperson/list/:type',
		name: 'prspersonlisttype',
		component: PrsPersonList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/prsperson/add/:type',
		name: 'prsperson',
		component: PrsPerson,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		path: '/prsperson/show/:itemId',
		name: 'prspersonshow',
		component: PrsPerson,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},

	/*{
		path: '/prsperson/add/:type/:typeView',
		name: 'prspersonadd',
		component: PrsPersonList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},
	{
		// /:typeView
		path: '/prsperson/show/:itemId',
		name: 'prspersonshow',
		component: PrsPersonList,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: true,
	},*/
	/*{
		path: '/prsperson',
		name: 'prsperson',
		component: PrsPerson,
		meta: {
			requiresAuth: true,
			layout: 'main',
		},
		props: false,
	},*/
	
]